import * as tslib_1 from "tslib";
import { throwError, throwError as observableThrowError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';
import { CSVDocument } from './Model/CSVDocument';
import { catchError, map } from "rxjs/operators";
var CsvUploadService = /** @class */ (function (_super) {
    tslib_1.__extends(CsvUploadService, _super);
    function CsvUploadService(http) {
        var _this = _super.call(this, http, {
            baseUrl: "" + environment.apiHost,
            path: '/makpak/setLieferungRequest'
        }) || this;
        _this.http = http;
        return _this;
    }
    CsvUploadService.prototype.uploadCSV = function (file, bensl) {
        var userId = bensl;
        var sendingData = new CSVDocument("dummy", file.name, file);
        return _super.prototype.create.call(this, file).pipe(map(function (res) {
            return res;
        }));
    };
    CsvUploadService.prototype.uploadFile = function (file) {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("mimeType", "");
        this.http.post("" + environment.apiHost + 'makpak/setLieferungRequest', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return observableThrowError(error); })).subscribe(function (data) { return console.log('success'); }, function (error) { return console.log(error); });
    };
    //SecureUpload
    CsvUploadService.prototype.secureUploadFile = function (file, wert, text, bezeichnung) {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("maklerPaket", wert + ";" + text + ";" + bezeichnung + ";" + file.name);
        return this.http.post("" + environment.apiHost + '/makpak/fileupload', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return observableThrowError(error); }), map(function (result) {
            console.log("to MaklerPaketStatus?");
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    CsvUploadService.prototype.uploadMakpakKraftForCheck = function (file, teilpaketKraft, bensl, linkEnd) {
        var formData = new FormData();
        formData.append("file", linkEnd.indexOf('/makpak/setorder') > 0 ? file : JSON.stringify(file));
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        formData.append("bensl", bensl);
        var httpOptions = {
            responseType: 'text'
        };
        return this.http.post("" + environment.apiHost + linkEnd, formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return JSON.parse(JSON.stringify(result));
            }
            console.log(result);
        }));
    };
    CsvUploadService.prototype.uploadMakpakKraftCheckResult = function (teilpaketKraft, bensl, linkEnd) {
        var formData = new FormData();
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        formData.append("bensl", bensl);
        var httpOptions = {
            responseType: 'text'
        };
        return this.http.post("" + environment.apiHost + linkEnd, formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return JSON.parse(JSON.stringify(result));
            }
            console.log(result);
        }));
    };
    CsvUploadService.prototype.uploadMakpakKraftForSave = function (file, teilpaketKraft, bensl) {
        var formData = new FormData();
        formData.append("file", JSON.stringify(file));
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        formData.append("bensl", bensl);
        return this.http.post("" + environment.apiHost + '/makpak/mphist', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return JSON.parse(JSON.stringify(result));
            }
            console.log(result);
        }));
    };
    CsvUploadService.prototype.uploadCheckedJson = function (file, teilpaketKraft, bensl) {
        var formData = new FormData();
        formData.append("file", file);
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        formData.append("bensl", bensl);
        return this.http.post("" + environment.apiHost + '/makpak/mphist', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    CsvUploadService.prototype.uploadMakpakKraft = function (file, teilpaketKraft) {
        var seperator = "?,";
        var formData = new FormData();
        formData.append("file", file);
        formData.append("maklerPaket", JSON.stringify(teilpaketKraft));
        console.log("Will send data with name " + teilpaketKraft.beschreibung);
        return this.http.post("" + environment.apiHost + '/makpak/mporigin', formData).pipe(map(function (res) { return res.json(); }), catchError(function (error) { return throwError(error); }), map(function (result) {
            if (result != null) {
                return result;
            }
            console.log(result);
        }));
    };
    return CsvUploadService;
}(RESTService));
export { CsvUploadService };
